import React from 'react';

import ProfileMenu from 'layouts/Menu/Profile';
import {
  RelationTypeEnum as RelationType,
  RelationType as RelationTypeDTO,
} from 'api/Types';

import PrivateRoute from './PrivateRoute';

export const PrivateRouteAdmin = ({
  component,
}: {
  component: React.ComponentType;
}) => <PrivateRoute component={component} allowed="admin" />;

export const PrivateRouteAuthenticated = ({
  component,
}: {
  component: React.ComponentType;
}) => <PrivateRoute component={component} />;

export const PrivateRouteEmployee: React.FC<{
  component?: React.ComponentType;
}> = ({ component = ProfileMenu }) => (
  <PrivateRoute component={component} allowed={RelationType.Employee} />
);

export const PrivateRouteTaxClaimant: React.FC<{
  component?: React.ComponentType;
}> = ({ component = ProfileMenu }) => (
  <PrivateRoute component={component} allowed={RelationType.TaxClaimant} />
);

export const PrivateRouteClient: React.FC<{
  component?: React.ComponentType;
}> = ({ component = ProfileMenu }) => (
  <PrivateRoute component={component} allowed={RelationType.Client} />
);
